import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { useDialog } from '@shared-ui/dialog-context';
import { useLocalization } from '@shared-ui/localization-context';

import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkIcon } from 'uitk-react-icons';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';
import { UitkText } from 'uitk-react-text';

import { StrikeoutPrice } from './strikeout-price';

const LinkTracked = ClickTracker(Link);
export interface StrikeoutPriceAndInfoContainerProps {
  strikeoutDisclaimer?: string;
  strikeOut?: string;
  dialogId?: string;
  wrapPrice?: boolean;
  dialogType?: string;
}

export const StrikeoutPriceAndInfoContainer: React.FunctionComponent<StrikeoutPriceAndInfoContainerProps> = ({
  strikeoutDisclaimer,
  strikeOut,
  dialogId,
  wrapPrice,
  dialogType,
}) => {
  const l10n = useLocalization();
  const [, dialogActions, DialogComponent] = useDialog(dialogId, dialogType);

  const openDialog = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dialogActions.openDialog();
  };

  const onDismiss = (): void => {
    dialogActions.closeDialog();
  };

  return (
    <React.Fragment>
      {strikeoutDisclaimer ? (
        <React.Fragment>
          <UitkMoreInfoTrigger>
            <LinkTracked linkName="Price Disclaimer Dialog" rfrr=".Price.DisclaimerDialog" role="button" onClick={openDialog}>
              <UitkIcon name="info_outline" className="pwa-theme--grey-700" />
              <StrikeoutPrice {...{ strikeOut, wrapPrice }} />
            </LinkTracked>
          </UitkMoreInfoTrigger>

          <DialogComponent>
            <UitkDialog returnFocusOnClose>
              <UitkDialogContent>
                <UitkText>{strikeoutDisclaimer}</UitkText>
              </UitkDialogContent>
              <UitkDialogFooter
                buttonOne={{
                  onClick: onDismiss,
                  text: l10n.formatText('close'),
                  type: 'tertiary',
                }}
              />
            </UitkDialog>
          </DialogComponent>
        </React.Fragment>
      ) : (
        <StrikeoutPrice {...{ strikeOut, wrapPrice }} />
      )}
    </React.Fragment>
  );
};
